<div class="all-vehicle mt-4">
  <div
    class="two-wheeler cursor-pointer ms-4"
    *ngFor="let vehicle of vehicleTypeListData.vehicleTypeList; let i = index"
    (click)="selectVehicle(vehicle)"
  >
    <span
      class="vehicle-card"
      [style.backgroundColor]="
        selectedVehicleType.optionNameValue == vehicle.optionNameValue
          ? vehicle?.backgroundColorActive
          : vehicle?.backgroundColor
      "
      [style.border]="
        selectedVehicleType === vehicle
          ? '1px solid ' + vehicle?.borderColor
          : 'none'
      "
      [ngClass]="{
        vehicleTypeSelected: selectedVehicleType === vehicle
      }"
    >
      <img
        src="{{ vehicle?.imageUrl }}"
        alt="{{ vehicle?.imageInformation }}"
        class="vehicle-image"
      /><span class="vehicle-name ms-3">{{ vehicle?.optionName }}</span>
    </span>
    <!-- <img
      *ngIf="env?.baseUrl == 'https://apex.renewbuyinsurance.com/' && isLast(i)"
      class="comming-soon-img"
      src="assets/icon/coming-soon.svg"
    /> -->
  </div>
</div>
